export default __webpack_public_path__ + "static/media/algas-02.937e45a2.jpg";